import axios from "axios";
import { logout } from "./authService";

const setupAxiosInterceptors = () => {
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // Verifica se é erro 401 (Não autorizado / Token expirado)
            if (error.response && error.response.status === 401) {

                // Evita loop infinito se já estiver na tela de login
                if (!window.location.pathname.includes("/auth/login")) {
                    console.warn("⚠️ Sessão expirada. Redirecionando para login...");

                    logout(); // Limpa o token do localStorage

                    // Opcional: Mostrar alerta visual
                    alert("Sua sessão expirou. Por favor, faça login novamente.");

                    // Redireciona para login
                    window.location.href = "/auth/login";
                }
            }
            return Promise.reject(error);
        }
    );
    console.log("✅ Axios interceptors configurados (Sessão Expirada -> Logout)");
};

export default setupAxiosInterceptors;
